import Offcanvas from 'react-bootstrap/Offcanvas';
import { OffcanvasBodyProps } from 'react-bootstrap';
import { IDrawerStyles, useDrawerStyles } from "..";

export interface DrawerBodyProps extends OffcanvasBodyProps {
    controlStyles?: IDrawerStyles | undefined;
}

const ComponentProps = (props: DrawerBodyProps): OffcanvasBodyProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.controlStyles;

    return componentProps;
}

export const DrawerBody: React.FC<DrawerBodyProps> = (props) => {  
    const styles: IDrawerStyles = props.controlStyles ??  useDrawerStyles();
    
    return (
        <Offcanvas.Body {...ComponentProps(props)} style={{ ...styles.container, ...props.style }}>
            {props.children}
        </Offcanvas.Body>

    );
};